export class StatusFilter {
  public static options: Array<string> = [
    "COMMITTED",
    "PROCESSING",
    "DISBURSED",
    "CLOSED",
    "CANCELED",
  ];
  public static supportRequestStatus: Array<string> = [
    "NEW",
    "IN-PROGRESS",
    "PROCESSING",
    "CANCELLED",
    "COMPLETED",
    "CLOSED",
  ];
  public static changeSupportRequestOption: Array<string> = [
    "NEW",
    "IN-PROGRESS",
    "CANCELLED",
    "CLOSED",
  ];
  public static assetListOptions: Array<string> = [
    "NEW",
    "LISTED",
    "PRE-LISTED",
    "SUBSCRIBED",
    "CANCELLED",
    "DISBURSED",
    "CLOSED",
  ];
  public static withdrawListOptions: Array<string> = ["CREDITED", "DEBITED"];
}

export class Report {
  public static types: Array<string> = [
    "INVESTMENT_REPORT",
    "INCOME_REPORT",
    "ACCOUNT_STATEMENT",
  ];
}

export class Asset {
  public static tenureTypes: Array<string> = ["DAILY", "MONTHLY", "YEARLY"];
  public static repaymentTypes: Array<string> = [
    "MONTHLY",
    "QUARTERLY",
    "YEARLY",
    "ON-MATURITY",
  ];
  public static riskCategoryList: Array<string> = ["LOW", "MEDIUM", "HIGH"];
  public static acceptedInvestmentTypes: Array<string> = [
    "SMART INVEST",
    "FIXED DEPOSIT",
    "SIP",
  ];
}

export enum Group {
  INVESTOR = "INVESTOR",
  STAFF = "STAFF",
  PARTNER = "PARTNER",
  ADMIN = "ADMIN",
  SR_ASSET_MANAGER = "SR_ASSET_MANAGER",
  INVESTOR_MANAGER = "INVESTOR_MANAGER",
  SALES = "SALES",
  ASSET_MANAGER = "ASSET_MANAGER",
  OPERATIONS = "OPERATIONS",
  INVESTOR_CHANNEL_PARTNER = "INVESTOR_CHANNEL_PARTNER",
  INTERNAL_SYSTEM = "INTERNAL_SYSTEM",
  INVESTOR_MASTER_CHANNEL_PARTNER = "INVESTOR_MASTER_CHANNEL_PARTNER",
}

export const HISTORY_COLUMN_NAMES = {
  MATURITY_DATE: "Maturity Date",
  ISSUER_NAME: "Issuer Name",
  PRODUCT_PAYOUT_FREQUENCY: "Product Payout Frequency",
  RENEWAL_PREFERENCE: "Renewal Preference",
  INVESTMENT_DATE: "Investment Date",
  STATE: "State",
  SUB_STATE: "Sub State",
  STATUS: "Status",
  INVESTMENT_AMOUNT: "Investment Amount",
  MATURITY_AMOUNT: "Maturity Amount",
  PRODUCT_INTEREST: "Product Interest",
  TENURE: "Tenure",
  CREATED_ON: "Created On",
};

export const INVESTOR_LIST_COLUMN_NAMES = {
  NAME: "Name",
  LEAD_STATUS: "Lead Status",
  CONTACT_NUMBER: "Contact Number",
  REGISTRATION_DATE: "Registration Date",
  EMAIL: "Email",
  GENDER: "Gender",
  FUNNEL_STATUS: "Funnel Status",
  LAST_COMMENT: "Last Comment",
  MANAGER: "Manager",
  REFERRED_BY: "Referred By",
  INFO: "Info",
};

export const INVESTOR_DETAIL_FD_INVESTMENT_COLUMN_NAMES = {
  ID: "Id",
  INVESTED_ON: "Invested On",
  MATURITY_DATE: "Maturity Date",
  AMOUNT: "Amount",
  EXPECTED_ROI: "Expected ROI",
  TENURE: "Tenure",
  STATUS: "Status",
  REPAYMENT: "Repayment",
  REPAYMENT_STATUS: "Repayment Status",
  SANITY_CHECK: "Sanity Check",
  DETAIL: "Detail",
};

export const FD_INVESTMENT_LIST_COLUMN_NAMES = {
  ID: "Id",
  USER_NAME: "User Name",
  EMAIL: "Email",
  CONTACT_NUMBER: "Contact Number",
  INVESTED_ON: "Invested On",
  MATURITY_DATE: "Maturity Date",
  AMOUNT: "Amount",
  EXPECTED_ROI: "Expected ROI",
  TENURE: "Tenure",
  STATUS: "Status",
  REPAYMENT: "Repayment",
  REPAYMENT_STATUS: "Repayment Status",
  SANITY_CHECK: "Sanity Check",
  INFO: "Info",
};

export const ASSET_LIST_COLUMN_NAMES = {
  ID: "ID",
  NAME: "Name",
  ISSUER_NAME: "Issuer",
  TYPE_OF_BOND: "Type of Bond",
  SECTOR: "Sector",
  SECURITY: "Security",
  ISIN: "ISIN",
  RATING: "Rating",
  RATING_AGENCY: "Rating Agency",
  ISSUE_DATE: "Created On",
  MATURITY_DATE: "Maturity Date",
  TENURE: "Tenure",
  COUPON_RATE: "Coupon rate",
  YTM_FINZACE: "YTM",
  INTEREST_FREQUENCY: "Interest frequency",
  PRINCIPAL_FREQUENCY: "Principal frequency",
  MIN_INVESTMENT: "Min Investment",
  FACE_VALUE: "Face value",
  ISSUE_SIZE: "Issue Size",
  SUBSCRIBED: "Subscribed",
  SECURED: "Secured",
  LISTED: "Listed",
  GUARANTEE: "Guarantee",
  REPAYMENT_PRIORITY: "Repayment Priority",
  RISK_CATEGORY: "Risk Category",
  DEBENTURE_TRUSTEE: "Debenture Trustee",
  MULTIPLES: "Multiples",
  PARTNER: "Partner",
  BROCHURE_LINK: "Brochure link",
  YTM_ON_OFFER: "YTM On Offer",
  STATUS: "Status",
  DETAILS: "Details",
};

// Columns left out of the default column set. MULTIPLES and BROCHURE_LINK
// have no backing data yet; the rest are available but secondary.
export const ASSET_LIST_DEFAULT_HIDDEN_COLUMNS = [
  "MULTIPLES",
  "BROCHURE_LINK",
  "ISSUER_NAME",
  "SECTOR",
  "TENURE",
  "ISSUE_SIZE",
  "SUBSCRIBED",
  "SECURED",
  "LISTED",
  "GUARANTEE",
  "REPAYMENT_PRIORITY",
  "RISK_CATEGORY",
  "DEBENTURE_TRUSTEE",
];

export const BOND_INVESTMENT_LIST_COLUMN_NAMES = {
  ID: "Id",
  PARTNER: "Partner",
  CREATED_ON: "Created On",
  AMOUNT: "Amount",
  TRADE_ID: "Trade ID",
  TRADE_DATE: "Trade Date",
  YTM: "YTM",
  UNIT: "Unit",
  ISIN: "ISIN",
  ASSET_ID: "Asset ID",
  STATUS: "Status",
  PROFILE_STATUS: "Profile Status",
  USER: "User",
  ACTION: "Action",
};
